import { getOrderList, getOrderDetail, getOrderDetails, getOrderStatusList, getOrderSeriesList } from "./postgre/orderApi";

export const getMyOrders = async () => getOrderList();

export const getOrderById = async (orderId) => getOrderDetail(orderId);

export { getOrderDetails, getOrderStatusList, getOrderSeriesList };
